import React, { useEffect, useState, useRef } from "react";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./branch.css";
import { ToastContainer } from "react-toastify";
import TextField from "@mui/material/TextField";
import { Avatar } from "@material-ui/core";
import Red_toast from "../alerts/red_toast";
import success_toast from "../alerts/success_toast";
import Save_button from "../buttons/save_button";

function Branchform({
  show,
  onHide,
  user,
  route,
  callback,
  current_user,
  setuser,
}) {
  const inputFile = useRef(null);
  const [File, setFile] = useState("");
  const [Fileurl, setFileurl] = useState("");
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [contact, setcontact] = useState("");
  const [address, setaddress] = useState("");
  const [links, setlinks] = useState("");
  const [isloading, setisloading] = useState(false);

  const assigncompany = async (input) => {
    const response = await fetch(
      `${route}/api/users/${current_user.id}/assign-branches/`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.access}`,
        },
        body: JSON.stringify({
          branch_list: [input.id],
        }),
      }
    );
    const json = await response.json();

    if (response.ok) {
      setuser({
        type: "SetCurrentUser",
        data: {
          ...current_user,
          branch_list: [
            ...current_user.branch_list,
            { id: input.id, name: input.name },
          ],
        },
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setisloading(true);
    const formData = new FormData();

    formData.append("name", name);
    formData.append("contact", contact);
    formData.append("email", email);

    formData.append("address", address);
    formData.append("social_links", links);
    formData.append("logo", File);

    const response = await fetch(`${route}/api/branch/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.access}`,
      },
      body: formData,
    });
    const json = await response.json();

    if (!response.ok) {
      setisloading(false);
      var error = Object.keys(json);
      if (error.length > 0) {
        Red_toast(`${json[error[0]]}`);
      }
    }

    if (response.ok) {
      setisloading(false);
      success_toast();
      callback({ type: "Create_table_history", data: json });
      setname("");
      setFileurl("");
      setcontact("");
      setaddress("");
      setemail("");
      setlinks("");
      // assigncompany(json);
    }
  };

  const onButtonClick = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };

  const handleimageselection = (event) => {
    const file = event.target.files[0];

    setFile(file);

    const reader = new FileReader();
    reader.onload = () => {
      setFileurl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="d-flex align-items-md-center"
        >
          <AddShoppingCartIcon className="me-2" />
          Add Branch
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-4 d-flex flex-column align-items-center">
              <Avatar
                src={Fileurl}
                className="mb-3"
                style={{ width: "100px", height: "100px" }}
                alt="image"
              />
              <input
                onChange={handleimageselection}
                id="select-file"
                type="file"
                ref={inputFile}
                style={{ display: "none" }}
              />
              <Button onClick={onButtonClick} shadow>
                Choose file
              </Button>
            </div>

            <div className="col-md-8">
              <TextField
                className="form-control   mb-3"
                id="outlined-basic"
                label="Name"
                value={name}
                onChange={(e) => {
                  setname(e.target.value);
                }}
                size="small"
                required
              />
              <TextField
                type="email"
                className="form-control   mb-3"
                id="outlined-basic"
                label="Email"
                value={email}
                onChange={(e) => {
                  setemail(e.target.value);
                }}
                size="small"
              />

              <TextField
                className="form-control  mb-3"
                id="outlined-basic"
                label="Contact"
                value={contact}
                onChange={(e) => {
                  setcontact(e.target.value);
                }}
                size="small"
              />
              <TextField
                multiline
                className="form-control   mb-3"
                id="outlined-basic"
                label="Address"
                value={address}
                onChange={(e) => {
                  setaddress(e.target.value);
                }}
                size="small"
              />

              <TextField
                multiline
                className="form-control  mb-3"
                id="outlined-basic"
                label="Social Links"
                value={links}
                onChange={(e) => {
                  setlinks(e.target.value);
                }}
                size="small"
              />
            </div>
          </div>

          <hr></hr>
          <div className="d-flex flex-row-reverse mt-2 me-2">
            <Save_button isloading={isloading} />
          </div>
        </form>
        <ToastContainer autoClose={1000} hideProgressBar={true} theme="dark" />
      </Modal.Body>
    </Modal>
  );
}

export default Branchform;
